import React from 'react';
import * as S from './ClockSwitch.styles';
import { ClockCircleOutlined, FieldBinaryOutlined } from '@ant-design/icons';

interface ClockSwitchProps {
  isClockActive: boolean;
  onClickAnalog: () => void;
  onClickDigital: () => void;
}

export const ClockSwitch: React.FC<ClockSwitchProps> = ({
  isClockActive: isClockActive,
  onClickAnalog: onClickAnalog,
  onClickDigital: onClickDigital,
}) => {
  return (
    <S.ButtonGroup $isFirstActive={isClockActive}>
      <S.Btn size="small" type="link" icon={<ClockCircleOutlined />} onClick={onClickAnalog} />
      <S.Btn size="small" type="link" icon={<FieldBinaryOutlined />} onClick={onClickDigital} />
    </S.ButtonGroup>
  );
};
